import React from "react";
import * as XLSX from "xlsx";
import { TbFile } from "react-icons/tb";
import { Button } from "@nextui-org/react";

const ExportExcel = ({ data, date }) => {
  const handleExport = () => {
    // Helpers
    const formatValue = (val) => (val > 0 ? val : 0);
    const displayValue = (val) => (val > 0 ? val : "-");

    // ---- Orders ----
    let orders = data?.orders?.map((doc, i) => {
      const ctipin = doc?.products1?.map((d) => d?.ctpin).join(", ");
      let cash = 0,
        card = 0,
        cashfree = 0,
        ma = 0,
        online = 0,
        udhar = 0,
        replace = 0;

      if (doc?.payment_type === "Other") {
        cash = formatValue(doc?.paid_struc?.cash);
        card = formatValue(doc?.paid_struc?.card);
        cashfree = formatValue(doc?.paid_struc?.cashfree);
        ma = formatValue(doc?.paid_struc?.ma);
        online = formatValue(doc?.paid_struc?.bank);
        udhar = formatValue(doc?.paid_struc?.loaned);
        replace = formatValue(doc?.paid_struc?.replace);
      } else if (doc?.payment_type === "Cash") {
        cash = formatValue(doc?.total);
      } else if (doc?.payment_type === "Card") {
        card = formatValue(doc?.total);
      } else if (doc?.payment_type === "Cashfree") {
        cashfree = formatValue(doc?.total);
      } else if (doc?.payment_type === "Ma") {
        ma = formatValue(doc?.total);
      } else if (doc?.payment_type === "Online") {
        online = formatValue(doc?.total);
      } else if (doc?.payment_type === "Udhar") {
        udhar = formatValue(doc?.total);
      }

      return {
        Sr: i + 1,
        Time: new Date(doc?.order_date).toLocaleTimeString("en-IN", {
          timeZone: "Asia/Kolkata",
        }),
        Products: doc?.products1
          ?.map((d) => `${d?.name} ${d?.desc}${doc.is2H ? " (2H)" : ""}`)
          .join(", "),
        Name: doc?.billName,
        Mobile: doc?.customer?.mobile,
        CTIPIN: ctipin,
        Customer: doc?.customer?.name,
        Cash: displayValue(cash),
        Card: displayValue(card),
        Cashfree: displayValue(cashfree),
        Ma: displayValue(ma),
        Online: displayValue(online),
        Udhar: displayValue(udhar),
        Replace: displayValue(replace),
        Total: displayValue(formatValue(doc?.total)),
        Type: "Order",
      };
    });

    // ---- Totals ----
    let cash = orders.reduce(
      (a, b) => a + (b.Cash !== "-" ? Number(b.Cash) : 0),
      0
    );
    let card = orders.reduce(
      (a, b) => a + (b.Card !== "-" ? Number(b.Card) : 0),
      0
    );
    let cashfree = orders.reduce(
      (a, b) => a + (b.Cashfree !== "-" ? Number(b.Cashfree) : 0),
      0
    );
    let online = orders.reduce(
      (a, b) => a + (b.Online !== "-" ? Number(b.Online) : 0),
      0
    );
    let ma = orders.reduce((a, b) => a + (b.Ma !== "-" ? Number(b.Ma) : 0), 0);
    let udhar = orders.reduce(
      (a, b) => a + (b.Udhar !== "-" ? Number(b.Udhar) : 0),
      0
    );
    let replace = orders.reduce(
      (a, b) => a + (b.Replace !== "-" ? Number(b.Replace) : 0),
      0
    );
    let total = cash + card + cashfree + online + ma + udhar + replace;

    // Add totals row
    orders.push({
      Sr: "",
      Time: "",
      Products: "---- Totals ----",
      Name: "",
      Mobile: "",
      CTIPIN: "",
      Customer: "",
      Cash: displayValue(cash),
      Card: displayValue(card),
      Cashfree: displayValue(cashfree),
      Ma: displayValue(ma),
      Online: displayValue(online),
      Udhar: displayValue(udhar),
      Replace: displayValue(replace),
      Total: displayValue(total),
      Type: "",
    });

    // ---- Excel ----
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(orders);

    XLSX.utils.book_append_sheet(wb, ws, "Report");

    XLSX.writeFile(wb, `Sales_Report_${date || "report"}.xlsx`);
  };

  return (
    <Button
      icon={<TbFile />}
      onClick={handleExport}
      color={"success"}
      auto
      size={"sm"}
    />
  );
};

export default ExportExcel;
